export const customStyles = {
    control: (provided, state) => ({
        ...provided, backgroundColor: '#212529', borderColor: state.isFocused ? '#b7343a' : '#495057', color: '#fff',
        minHeight: '45px', height: '45px', boxShadow: state.isFocused ? '0 0 0 1px #b7343a' : 'none',
        '&:hover': { borderColor: '#b7343a' }
    }),
    valueContainer: (provided) => ({ ...provided, height: '45px', padding: '0 6px', display: 'flex', alignItems: 'center' }),
    input: (provided) => ({ ...provided, margin: '0px', color: '#fff', padding: 0 }),
    singleValue: (provided) => ({ ...provided, color: '#fff' }),
    menu: (provided) => ({ ...provided, backgroundColor: '#212529', zIndex: 9999, border: '1px solid #495057' }),
    option: (provided, state) => ({
        ...provided, backgroundColor: state.isSelected ? '#b7343a' : state.isFocused ? '#343a40' : '#212529',
        color: '#fff', cursor: 'pointer', '&:active': { backgroundColor: '#b7343a' }
    }),
    multiValue: (provided) => ({ ...provided, backgroundColor: '#343a40' }),
    multiValueLabel: (provided) => ({ ...provided, color: '#fff' }),
    multiValueRemove: (provided) => ({ ...provided, color: '#fff', ':hover': { backgroundColor: '#b7343a', color: 'white' } }),
};

export const transformToSelectOptions = (data, valueKey, labelKey) => {
    if (!data || !Array.isArray(data)) return [];
    return data.map(item => ({ value: item[valueKey], label: item[labelKey] }));
};